<style scoped lang="scss">
    @media print
    {
        .no-print, .no-print *
        {
            display: none !important;
        }
        .uk-width-medium-5-10
        {
            width:50% !important;
        }
    }
</style>

<template>
    <div class="uk-container">
        <div class="uk-grid-margin">

            <h1>Email Manifest For Application ID #{{ application.id }}</h1>

            <div class="uk-width-1-1 uk-margin-top-remove">
                <hr class="uk-width-1-1  uk-margin-top-remove">
                <ul class="uk-margin-bottom">
                    <li v-for="request in requests">{{ request.category.document_category_name }} - {{ request.household_member.first_name }} {{ request.household_member.last_name }}</li>
                </ul>
            </div>
            <hr/>
            <div class="uk-grid">
                <div class="uk-width-1-1">
                    <h3 class="uk-margin-top">Instructions:</h3>
                    <ol style="max-width:35em;" class="uk-margin-bottom">
                        <li class="uk-margin-small-bottom">Press control + a on your keyboard (command + a on mac).</li>
                        <li  class="uk-margin-small-bottom">hit control + c (command + c on mac) to select this message and copy it to your clipboard.</li>
                        <li  class="uk-margin-small-bottom"> <a :href="application.program.email ? 'mailto:' + application.program.email + '?subject=Documents for Application ID ' + application.id : 'mailto:?subject=Documents for Application ID ' + application.id" class="uk-button uk-button-min"><i class="uk-icon-envelope-o"></i> Click this link to open your email</a> </li>
                        <li  class="uk-margin-small-bottom"> Click your mouse in the body of your email and, using your keyboard, hold down the control + v (command + v on mac) keys at the same time to paste this document list into your message.</li>
                        <li  class="uk-margin-small-bottom"><strong><em>Be sure to include your ID number in the subject line of your email.</em></strong></li>
                        <li  class="uk-margin-small-bottom">Hit send.</li>
                    </ol>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "EmailManifest",
        props: ['application', 'requests']
    }
</script>
